module.exports = __webpack_public_path__ + "img/90.4.NH3-N.58e360e0.png";